import Cookies from 'js-cookie';

class CookiesConsentStatusClass {
    cookieName = 'cookie-consent';
    validityDays = 365;
    changeHandlers = [];

    constructor() {
        console.log('CookiesConsentStatusClass constructor');
        if (!this.isEU() && !this.hasConsented()) {
            console.log('Not in EU and no consent, accepting all cookies');
            // accept all cookies by default if not in EU
            this.setAccepted(['analytics', 'marketing', 'essential']);
        }
    }
    setAccepted(acceptedTypes) {
        Cookies.set(this.cookieName, acceptedTypes.join(','), { expires: this.validityDays });

        this.changeHandlers.forEach(handler => {
            handler(acceptedTypes);
        });
    }
    isAccepted(type) {
        console.log('CookiesConsentStatusClass isAccepted', type);
        const val = Cookies.get(this.cookieName);
        const acceptedTypes = val ? val.split(',') : [];
        return acceptedTypes.includes(type);
    }
    hasConsented() {
        return Cookies.get(this.cookieName) !== undefined;
    }
    isEU () {
        return document.body.dataset.countryInEu === 'true';
    }
    registerChangeHandler (callback) {
        this.changeHandlers.push(callback);
    }
}

window.cookieConsentStatus = window.cookieConsentStatus || new CookiesConsentStatusClass();

export let CookiesConsentStatus = window.cookieConsentStatus;